<div class="rounded-lg bg-badge flex-col flex-start-stretch overflow-hidden md:flex-row">
    <div
        class="cursor-pointer flex justify-start items-center gap-x-2 p-4 pb-0 md:p-6 md:min-w-[260px] md:w-[260px] md:min-h-[110px] bg-white bg-opacity-[0.06]"
    >
        <img
            class="w-9 h-9 md:w-16 md:h-16 rounded-full object-cover"
            [src]="collection.token_logo_url || '/assets/imgs/fallback.png'"
            [alt]="collection.token_name"
        />
        <div class="flex-1 min-w-0">
            <div class="font-semibold text-xs max-md:max-w-[60px] md:text-base truncate">{{collection.token_name}}</div>

            <div class="flex-start-center md:gap-x-5 md:block md:space-y-1 flex-1 min-w-0 text-xs leading-[18px]">
                <div class="flex-start-center gap-x-3 md:gap-x-0">
                    <span class="text-sub-text">Holdings</span>
                    <span>{{collection.nft_count | number:'1.0-0'}}</span>
                </div>
                <div class="divider-vertical h-4 md:hidden"></div>
                <div class="flex-start-center gap-x-3 md:gap-x-0">
                    <span class="text-sub-text">Floor Price</span>
                    <span>{{collection.floor_price || '-'}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="relative px-4 py-4 md:px-5 md:py-2 overflow-hidden flex-1 flex items-center">
        <div class="cdk-virtual-scroll-data-source-example w-full">
            <cdk-virtual-scroll-viewport
                orientation="horizontal"
                [itemSize]="commonService.isMobile? 74 : 106"
                [minBufferPx]="300"
                [maxBufferPx]="500"
                class="example-viewport h-[74px] md:h-[102px]"
            >
                <div
                    *cdkVirtualFor="let token of collection.token_id_list;let i = index"
                    class="min-w-[64px] w-[64px] md:min-w-[96px] md:w-[96px] text-center mr-2.5"
                >
                    <div class="relative overflow-hidden w-full">
                        <img
                            class="absolute top-1.5 right-1.5 w-4 h-4 rounded-full"
                            [src]="commonService.getChainImg(collection.chain_name)"
                            [alt]="collection.chain_name"
                        />

                        <img
                            class="w-full aspect-square rounded-xl object-cover bg-white"
                            nz-image
                            [nzSrc]="getTokenImg(token)"
                            [alt]="collection.token_name"
                            loading="lazy"
                            (error)="errorHandler($event)"
                        />

                        <div class="absolute bottom-0 left-0 w-full py-0.5 bg-[#3F4C5E] text-center text-white rounded-b-xl text-xs truncate px-1">
                            #{{token}}
                        </div>

                        <div
                            *ngIf="collection.token_type === 'ERC1155'"
                            class="absolute top-0 left-0 text-xs bg-[#3F4C5E] px-2 py-0.5 rounded-tl-xl rounded-br-xl"
                        >
                            x {{collection.token_amount_list[i]}}
                        </div>
                    </div>
                </div>
            </cdk-virtual-scroll-viewport>
        </div>
    </div>
</div>
